import React from 'react'
import './poolVerificationMemberCard.css'

function INCSUBPoolVerificationMemberCard({ member, index }) {
  return (
    <div className='INCSUBPoolVerificationMemberCard_ctn' style={{ backgroundColor: index % 2 !== 0 ? 'rgba(72, 128, 255, 0.06)' : '#fff' }} >
      <div className='INCSUBPoolverification_member'>
        <div className='INCSUBVerificationpools_row_host_img'>
          <img className='INCSUB_UserImgTag' src={member && member.memberImage ? member.memberImage : '/assets/icons/common/defaultImage.png'} alt={`${'default'} img`} />
        </div>
        <div className='INCSUBVerificationDetails_row_handledBy_time_date'>
          <div className='INCSUBVerificationDetailspools_row_handledBy_name'>{member && member?.memberName}
            <div className='INCSUBVerificationDetails_row_host'>{member && member.host ? "Host" : "Member"}</div>
          </div>

          <div className='INCSUBVerificationpools_row_handledBy_time_date'>
            {member && member?.poolJoiningDate}
          </div>
        </div>
      </div>
    </div>
  )
}

export default INCSUBPoolVerificationMemberCard;
